import DesShareLibrarySearchBoxViewModel from 'viewmodel/DesShareLibrarySearchBoxViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';

export default class DesShareLibrarySearchBox extends DesBaseCatalogAcc {
    constructor() {
        super(DesShareLibrarySearchBoxViewModel);
    }

    get locale() {
        return this.getAttribute('locale') || 'en_US';
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'locale'];
    }
}

if (!window.customElements.get('des-share-library-search-box')) {
    window.customElements.define('des-share-library-search-box', DesShareLibrarySearchBox);
}
